// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--H50ks","flex":"flex--st7Jl","button":"button--TJ5eq","icon":"icon--B442v","title":"title--s3Taz","delimiter":"delimiter--gKljR","subTitle":"subTitle--MAI6S"};